<messages
    [template]="template"
    [templateId]="templateId"
    [selectedUserId]="selectedUserId"
    [isOnlyPreview]="isOnlyPreview"
    [previewMediaType]="previewMediaType"
    [templateUpdateModel]="templateUpdateModel"
    [templateFileRef]="templateFileRef"
    [hasValueFromDb]="hasValueFromDb"
    [userPermissions]="userPermissions"
    [communicationsCategoryId]="communicationsCategoryId"
    [activeIndex]="activeIndex"
    [disablePasteEvent]="disablePasteEvent"
></messages>
